import { render, staticRenderFns } from "./warehouseSettings.vue?vue&type=template&id=cc8768ac&scoped=true"
import script from "./warehouseSettings.vue?vue&type=script&lang=js"
export * from "./warehouseSettings.vue?vue&type=script&lang=js"
import style0 from "./warehouseSettings.vue?vue&type=style&index=0&id=cc8768ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8768ac",
  null
  
)

export default component.exports